import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  activeScan: belongsTo('a11y-scan', { inverse: null }),
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  scans: hasMany('a11y-scan', { inverse: null }),
});
